import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from './ui/dropdown-menu';
import { useAuth } from '../context/AuthContext';

const LANGS = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
];

export default function LanguageSwitcher({ compact = false }) {
  const { i18n } = useTranslation();
  const { updateLanguage } = useAuth();
  const current = LANGS.find(l => l.code === i18n.language) || LANGS[0];
  const handleChange = (code) => {
    if (updateLanguage) {
      updateLanguage(code);
    } else {
      i18n.changeLanguage(code);
    }
  };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="flex items-center gap-1.5 px-2.5 py-1.5 rounded-md hover:bg-white/10 text-white text-sm font-medium transition-colors" data-testid="lang-switcher">
        <Globe className="w-4 h-4" />
        {!compact && <span className="uppercase">{current.code}</span>}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-white">
        {LANGS.map(l => (
          <DropdownMenuItem
            key={l.code}
            onClick={() => handleChange(l.code)}
            className={`gap-2 cursor-pointer ${l.code === current.code ? 'bg-[#F0EFEA] font-semibold' : ''}`}
            data-testid={`lang-${l.code}`}
          >
            <span className="text-base">{l.flag}</span>
            <span>{l.label}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
